import "@gojek/typeface-maison-neue";
import firebase from "firebase/app";
import React from "react";
import "./App.css";
import { useAuthState } from "./authentication/hooks/useAuthState";
import { UserProvider } from "./common/hooks/UserContext";
import LoadingPage from "./common/pages/LoadingPage";
import AppRouter from "./common/routers/AppRouter";

function App() {
  const { loading, error, signOut } = useAuthState(firebase.auth());

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <UserProvider>
      <AppRouter
        error={error}
        signOut={signOut}
        firebaseAuth={firebase.auth()}
      />
    </UserProvider>
  );
}

export default App;
